/**
 * @name isDeviceIos
 */
export const isDeviceIos = (): boolean =>
  /iPad|iPhone|iPod/.test(navigator.userAgent);
